var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello row"},[_c('div',{attrs:{"id":"adminMenu"}},[_c('h3',[_vm._v("PEA Admin options")]),_c('admin-nav')],1),_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"adminContent"}},[_c('br'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }